export function useCashierLoader({ autoLoad } = { autoLoad: true }) {
  const store = shallowRef<ReturnType<(typeof import('~/store/cashier'))['useCashierStore']> | null>(null);

  async function load(): Promise<typeof store.value> {
    const { useCashierStore } = await import('~/store/cashier');
    store.value = useCashierStore();
    return store.value;
  }

  if (autoLoad) {
    load();
  }

  return { store, load };
}
